import { Component, OnDestroy, OnInit } from '@angular/core';

import { LoaderState } from './loader';
import { LoaderService } from './loader.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';

@Component({
  selector: 'zero-waste-loader',
  standalone: true,
  imports: [ProgressSpinner, NgIf],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;
  loaderStateSubscription$?: Subscription;

  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderStateSubscription$ = this.loaderService.loaderState.subscribe(
      (state: LoaderState) => {
        setTimeout(() => (this.show = state.show), 100);
      }
    );
  }

  ngOnDestroy(): void {
    this.loaderStateSubscription$?.unsubscribe();
  }
}
